import React, { useState } from "react";

export default function WeatherTemperature(props) {
  const [unit, setUnit] = useState("celsius");

  function showFahrenheit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }

  function showCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  function fahrenheit() {
    return Math.round((props.celsius * 9) / 5 + 32);
  }

  if (unit === "celsius") {
    return (
      <div className="weatherTemperatureCelsius">
        {" "}
        <span className="number">{props.celsius}</span>
        <span className="unit">
          °C |{" "}
          <a href="/" onClick={showFahrenheit} className="text-decoration-none">
            °F{" "}
          </a>
        </span>
      </div>
    );
  } else {
    return (
      <div className="weatherTemperatureFahrenheit">
        {" "}
        <span className="number">{fahrenheit()}</span>
        <span className="unit">
          <a href="/" onClick={showCelsius} className="text-decoration-none">
            {" "}
            °C{" "}
          </a>
          | °F
        </span>
      </div>
    );
  }
}
